export const homePages = [
  { id: 1, title: 'Home 1', href: '/' },
  { id: 2, title: 'Home 2', href: '/home-2' },
  { id: 3, title: 'Home 3', href: '/home-3' },
  { id: 4, title: 'Home 4', href: '/home-4' },
  { id: 5, title: 'Home 5', href: '/home-5' },
  { id: 6, title: 'Home 6', href: '/home-6' },
  { id: 7, title: 'Home 7', href: '/home-7' },
  { id: 8, title: 'Home 8', href: '/home-8' },
  { id: 9, title: 'Home 9', href: '/home-9' },
  { id: 10, title: 'Home 10', href: '/home-10' },
  { id: 11, title: 'Home 11', href: '/home-11' },
  { id: 12, title: 'Home 12', href: '/home-12' },
  { id: 13, title: 'Home 13', href: '/home-13' },
  { id: 14, title: 'Home 14', href: '/home-14' },
  { id: 15, title: 'Home 15', href: '/home-15' },
  { id: 16, title: 'Home 16', href: '/home-16' },
  { id: 17, title: 'Home 17', href: '/home-17' },
  { id: 18, title: 'Home 18', href: '/home-18' },
  { id: 19, title: 'Home 19', href: '/home-19' },
  { id: 20, title: 'Home 20', href: '/home-20' },
  { id: 21, title: 'Home 21', href: '/home-21' },
  { id: 22, title: 'Home 22', href: '/home-22' },
]

export const shopList = [
  {
    id: 1,
    href: '/shop-1',
    title: 'Shop List V1',
  },
  {
    id: 2,
    href: '/shop-2',
    title: 'Shop List V2',
  },
  {
    id: 3,
    href: '/shop-3',
    title: 'Shop List V3',
  },
  {
    id: 4,
    href: '/shop-4',
    title: 'Shop List V4',
  },
  {
    id: 5,
    href: '/shop-5',
    title: 'Shop List V5',
  },
  {
    id: 6,
    href: '/shop-6',
    title: 'Shop List V6',
  },
  {
    id: 7,
    href: '/shop-7',
    title: 'Shop List V7',
  },
  {
    id: 8,
    href: '/shop-8',
    title: 'Shop List V8',
  },
  {
    id: 9,
    href: '/shop-9',
    title: 'Shop List V9',
  },
  {
    id: 10,
    href: '/shop-10',
    title: 'Shop Item Style',
  },
  {
    id: 11,
    href: '/shop-11',
    title: 'Horizontal Scroll',
  },
]
export const shopDetails = [
  { id: 1, href: '/product2_variable/1', title: 'Shop Detail V1' },
  { id: 2, href: '/product7_v2/1', title: 'Shop Detail V2' },
  { id: 3, href: '/product8_v3/1', title: 'Shop Detail V3' },
  { id: 4, href: '/product9_v4/1', title: 'Shop Detail V4' },
  { id: 5, href: '/product10_v5/1', title: 'Shop Detail V5' },
  { id: 6, href: '/product11_v6/1', title: 'Shop Detail V6' },
  { id: 7, href: '/product12_v7/1', title: 'Shop Detail V7' },
  { id: 8, href: '/product13_v8/1', title: 'Shop Detail V8' },
  { id: 9, href: '/product14_v9/1', title: 'Shop Detail V9' },
  { id: 10, href: '/product15_v10/1', title: 'Shop Detail V10' },
  { id: 11, href: '/product16_v11/1', title: 'Shop Detail V11' },
]

export const additionalShopPageitems = [
  { id: 1, href: '/shop-12', title: 'Collection Grid' },
  { id: 2, href: '/product1_simple/1', title: 'Simple Product' },
  { id: 3, href: '/product2_variable/2', title: 'Variable Product' },
  { id: 4, href: '/product3_external/2', title: 'External Product' },
  { id: 5, href: '/product4_grouped/2', title: 'Grouped Product' },
  { id: 6, href: '/product5_onsale/2', title: 'On Sale' },
  { id: 7, href: '/product6_outofstock/2', title: 'Out of Stock' },
  { id: 8, href: '/shop_cart', title: 'Shopping Cart' },
  { id: 9, href: '/shop_checkout', title: 'Checkout' },
  { id: 10, href: '/shop_order_complete', title: 'Order Complete' },
  { id: 11, href: '/shop_order_tracking', title: 'Order Tracking' },
]

export const blogmenuItems = [
  {
    id: 1,
    href: '/blog_list1',

    title: 'Blog V1',
  },
  {
    id: 2,
    href: '/blog_list2',

    title: 'Blog V2',
  },
  {
    id: 3,
    href: '/blog_list3',

    title: 'Blog V3',
  },
  {
    id: 4,
    href: '/blog_single/1',

    title: 'Blog Detail',
  },
]

export const othersMenuItems = [
  {
    id: 1,
    href: '/account_dashboard',
    title: 'My Account',
  },
  {
    id: 2,
    href: '/LoginOrRegister',
    title: 'Login / Register',
  },
  {
    id: 3,
    href: '/store_location',
    title: 'Store Locator',
  },
  {
    id: 4,
    href: '/lookbook',
    title: 'Lookbook',
  },
  {
    id: 5,
    href: '/faq',
    title: 'Faq',
  },
  {
    id: 6,
    href: '/terms',
    title: 'Terms',
  },
  {
    id: 7,
    href: '/page-not-found',
    title: '404 Error',
  },
  {
    id: 8,
    href: '/coming_soon',
    title: 'Coming Soon',
  },
]
//有用到
export const dashboardMenuItems = [
  {
    id: 1,
    href: '/MemberCenter/account_dashboard',
    title: '會員專區',
  },
  {
    id: 2,
    href: '/MemberCenter/account_orders',
    title: '訂單查詢',
  },
  {
    id: 3,
    href: '/MemberCenter/account_coupon',
    title: '會員優惠券',
  },
  {
    id: 4,
    href: '/MemberCenter/account_edit_address',
    title: '寄送地址',
  },
  {
    id: 5,
    href: '/MemberCenter/account_edit',
    title: '會員基本資料',
  },
  {
    id: 6,
    href: '/MemberCenter/account_change_password',
    title: '修改密碼',
  },
  {
    id: 7,
    href: '/MemberCenter/account_wishlist',
    title: '願望清單',
  },
  {
    id: 8,
    href: '/Logout',
    title: '登出會員',
  },
]

export const storeInfoMenuItems = [
  { title: '門市資訊', href: '/store_location' },
  { title: '商店簡介', href: '/intro' },
  { title: '品牌故事', href: '/brand-story' },
  { title: '購物說明', href: '/shopping-info' },
  // { title: '商店客服', href: '/store-service' },
  // { title: '留言給客服', href: '/contact' }, // 直接導到你剛做好的留言頁
  { title: '會員權益說明', href: '/member-rights' },
  { title: '隱私權及使用條款', href: '/privacy-policy' },
]
